const countWithNull = (list, match) => {
  var totalCount = 0;
  var matchCount = 0;
  var nullCount = 0;
  list.forEach((element) => {
    totalCount++;
    if (element === null) nullCount++;
    else if (element === match) matchCount++;
  });

  return { total: totalCount, match: matchCount, null: nullCount };
};

export default countWithNull;
